import script from "./H5JumpConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./H5JumpConfig.vue?vue&type=script&setup=true&lang=ts"

import "./H5JumpConfig.vue?vue&type=style&index=0&id=117455e7&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117455e7"]])

export default __exports__